import { useState } from "react";
import { useAuth } from "@/components/providers/auth-provider";
import { useMutation } from "@tanstack/react-query";
import { fetchWithAuth } from "@/lib/api/client";
import { User, Mail, Save, Loader2 } from "lucide-react";

export default function PerfilPage() {
  const { user } = useAuth();
  const [nombre, setNombre] = useState(user?.name || "");
  const [email] = useState(user?.email || "");
  const [saved, setSaved] = useState(false);

  const mutation = useMutation({
    mutationFn: (data: { nombre: string }) =>
      fetchWithAuth("/api/v1/usuarios/perfil", { method: "PUT", body: JSON.stringify(data) }),
    onSuccess: () => {
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    mutation.mutate({ nombre });
  };

  return (
    <div className="p-6 max-w-2xl">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Perfil de usuario</h1>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="bg-white rounded-lg border border-gray-200 p-6 space-y-4">
          <div>
            <label htmlFor="nombre" className="block text-sm font-medium text-gray-700 mb-1">
              <span className="flex items-center gap-2"><User className="w-4 h-4" /> Nombre</span>
            </label>
            <input
              id="nombre"
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
              placeholder="Tu nombre"
            />
          </div>

          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              <span className="flex items-center gap-2"><Mail className="w-4 h-4" /> Email</span>
            </label>
            <input
              id="email"
              type="email"
              value={email}
              disabled
              className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm bg-gray-50 text-gray-500 cursor-not-allowed"
            />
            <p className="text-xs text-gray-400 mt-1">El email se gestiona a través de Keycloak</p>
          </div>
        </div>

        {mutation.isError && (
          <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
            {mutation.error instanceof Error ? mutation.error.message : "Error al guardar"}
          </div>
        )}

        {saved && (
          <div className="p-3 bg-green-50 border border-green-200 rounded-lg text-sm text-green-700">
            Perfil actualizado correctamente
          </div>
        )}

        <button
          type="submit"
          disabled={mutation.isPending}
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors"
        >
          {mutation.isPending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
          Guardar cambios
        </button>
      </form>
    </div>
  );
}
